// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Sweden from '../_raw/flag/icon_flag_sweden.png';

export default () => <img src={Sweden} alt="Sweden" />;
